export default "__VITE_ASSET__CEjLMtOz__"